import { Button, styled } from "@mui/material";

const StyledButton = styled(Button)(({ theme }) => ({
  borderRadius: theme.shape.borderRadius,
  textTransform: "capitalize",
  "&.MuiButton-sizeMedium": {
    padding: theme.spacing(0, 2.25),
    minWidth: 84,
    height: 40,
    fontWeight: 600,
    fontSize: "1rem",
    "&.MuiButton-text": {
      fontSize: "0.875rem",
    },
  },
  // "&.MuiButton-sizeSmall": {
  //   fontWeight: 600,
  // },
  "&.MuiButton-sizeLarge": {
    fontWeight: 600,
  },
}));

export default StyledButton;
